import DropZoneInDialog from "./DropZoneInDialog";

export default DropZoneInDialog;